module.exports = __webpack_public_path__ + "img/construct-in-white-font-logo.8ea26acd.png";